(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBg = this;
      const whiteTextSelectors =
        '#span-summary-text, #span-list-text, #icon-caret-navbar, #span-search-text, #Search-In-Modal, #icon-reset-navbar, #icon-search-navbar, #icon-close-navbar, #span-account-text, #span-return-text, #span-cart-text, #icon-cart, #icon-burger, #icon-close-burger';
      this.whiteTextElements = document.querySelectorAll(whiteTextSelectors);
      this.logoHeader = this.header.querySelectorAll('.header__heading-logo');
      this.bannerAboveHeader = document.querySelector('#banner-above-header');

      this.whiteTextElements.forEach((element) => {
        element.classList.add('transition-header-elements');
      });
      this.logoHeader.forEach((element) => {
        element.classList.add('transition-header-elements');
      });

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      const headerHeightObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const headerHeight = Math.ceil(entry.contentRect.height);
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        });
      });
      headerHeightObserver.observe(this.headerBg);

      if (this.bannerAboveHeader) {
        const bannerAboveHeaderHeightObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            const bannerOverHeaderHeight = Math.ceil(entry.target.clientHeight);
            document.documentElement.style.setProperty(
              '--banner-above-header-height',
              `${bannerOverHeaderHeight > 0 ? bannerOverHeaderHeight - 1 : bannerOverHeaderHeight}px`
            );
          });
        });
        bannerAboveHeaderHeightObserver.observe(this.bannerAboveHeader);
      } else {
        document.documentElement.style.setProperty('--banner-above-header-height', '0px');
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.updateAtTopClass = () => {
        document.body.classList.toggle('at-top-of-page', (window.scrollY || document.documentElement.scrollTop) <= 5);
      };
      this.updateAtTopClass();
      window.addEventListener('scroll', this.updateAtTopClass, { passive: true });

      if (document.getElementsByClassName('announcement-bar-section')[0].offsetHeight > 0) {
        document.body.classList.toggle('has-announcement-bar', !!document.querySelector('.announcement-bar-section'));
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.updateAtTopClass) {
        window.removeEventListener('scroll', this.updateAtTopClass);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.top) {
        this.header.classList.add('scrolled-past-header');
        this.headerBg.classList.remove('transparent-background-1-for-header');
        this.headerBg.classList.add('scrolled-past-header');
        this.headerBg.classList.add('color-background-1');
        if (window.isWhiteText) {
          this.whiteTextElements.forEach((element) => {
            element.classList.remove('text-white-animated');
          });
          this.logoHeader.forEach((element) => {
            element.classList.remove('logo-in-negative');
          });
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.headerBg.classList.remove('transparent-background-1-for-header');
        this.headerBg.classList.add('scrolled-past-header');
        this.headerBg.classList.add('color-background-1');
        if (window.isWhiteText) {
          this.whiteTextElements.forEach((element) => {
            element.classList.remove('text-white-animated');
          });
          this.logoHeader.forEach((element) => {
            element.classList.remove('logo-in-negative');
          });
        }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        if (!this.preventHide) {
          this.header.classList.remove('scrolled-past-header');
          this.headerBg.classList.remove('scrolled-past-header');
          this.headerBg.classList.remove('color-background-1');
          this.headerBg.classList.add('transparent-background-1-for-header');
          if (window.isWhiteText) {
            this.whiteTextElements.forEach((element) => {
              element.classList.add('text-white-animated');
            });
            this.logoHeader.forEach((element) => {
              element.classList.add('logo-in-negative');
            });
          }
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
